import createReducer from '../utils/createReducer';
import actions from '../actions/actions';

const initialState = {};

const actionHandlers = {
    [actions.FETCH_INITIAL_DATA_SUCCESS](state, {payload}) {
        return {
            ...state,
            ...payload.response.abacus
        };
    }
};

export default createReducer(actionHandlers, initialState);
